import type { CardProps } from '@nuxt/ui'

const adminCard: NonNullable<CardProps['ui']> = {
  root: 'max-w-5xl mx-0 rounded-none sm:rounded-lg',
  footer: 'rounded-none sm:rounded-b-lg flex justify-end bg-gray-50',
}
const modalCard: NonNullable<CardProps['ui']> = {
  root: 'ring-0 md:ring-1 shadow-none md:shadow-sm',
}
const publicCard: NonNullable<CardProps['ui']> = {
  footer: 'bg-gray-50',
}
const carouselCardThreeWithoutBorder: NonNullable<CardProps['ui']> = {
  root: 'block w-auto lg:w-full relative group focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-hidden transition duration-300 ring-0 divide-none',
  body: 'sm:p-0 p-0',
  footer: 'p-0 pt-3 sm:p-0 sm:pt-3',
}
const carouselCardFourWithoutBorder: NonNullable<CardProps['ui']> = {
  root: 'block w-72 lg:w-full relative group focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-hidden transition duration-300 ring-0 divide-none',
  body: 'sm:p-0 p-0',
  footer: 'p-0 pt-3 sm:p-0 sm:pt-3',
}
const carouselCardFiveWithBorder: NonNullable<CardProps['ui']> = {
  root: 'block w-56 lg:w-full relative group focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-hidden transition duration-300 divide-none',
  body: 'sm:p-0 p-0',
  footer: 'py-3 px-4 sm:py-3 sm:px-4',
}
const cardFiveFlexibleWithBorder: NonNullable<CardProps['ui']> = {
  root: 'block w-full  relative group focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-hidden transition duration-300 divide-none',
  body: 'sm:p-0 p-0',
  footer: 'py-2 px-3 sm:py-3 sm:px-4',
}
const fullWidthCard: NonNullable<CardProps['ui']> = {
  root: 'ring-0',
  body: 'p-0',
}
const pricesCard: NonNullable<CardProps['ui']> = {
  root: 'shadow-md mb-2 md:mb-5',
}
const pricesSummaryCard: NonNullable<CardProps['ui']> = {
  body: 'p-4 sm:p-6',
  header: 'px-6 p-4 sm:py-4 sm:px-6 bg-gray-50',
}

const mapCard: NonNullable<CardProps['ui']> = {
  root: 'block w-80 relative group focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-hidden transition duration-300 ring-0 divide-none',
  body: 'sm:p-0 p-0',
  footer: 'p-0 pt-3 sm:p-0 sm:pt-3',
}
export {
  adminCard,
  modalCard,
  publicCard,
  carouselCardThreeWithoutBorder,
  carouselCardFourWithoutBorder,
  carouselCardFiveWithBorder,
  cardFiveFlexibleWithBorder,
  fullWidthCard,
  pricesCard,
  pricesSummaryCard,
  mapCard,
}
